module.exports = __webpack_public_path__ + "static/media/fire_color_big.59cd9fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/fire_color_big.png
// module id = ./src/assets/media/icons/fire_color_big.png
// module chunks = 16